import { render, staticRenderFns } from "./AscTabBody.vue?vue&type=template&id=1d736a81&"
import script from "./AscTabBody.vue?vue&type=script&lang=js&"
export * from "./AscTabBody.vue?vue&type=script&lang=js&"
import style0 from "./AscTabBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTabsItems})
